var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.998%",
    y1: "21.442%",
    x2: "71.595%",
    y2: "77.223%",
    id: "skill-logo-fill"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "73.407%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.299 10.754c3.397-1.92 7.754-.757 9.733 2.597a6.897 6.897 0 01-2.35 9.418l-.218.128-7.294 4.121a2.656 2.656 0 01-1.342 2.626 2.776 2.776 0 01-3.743-.999 2.653 2.653 0 01.987-3.671 2.781 2.781 0 012.995.175l7.294-4.12a4.776 4.776 0 001.778-6.61c-1.33-2.255-4.215-3.079-6.535-1.906l-.203.109-4.258 2.405a1.11 1.11 0 01-1.497-.4 1.06 1.06 0 01.288-1.4l.107-.068 4.258-2.405zM16.427.003l.12.018 4.743 1.07.044.013a.84.84 0 01.138.056l.079.047.087.067.085.086.064.086.056.104.039.104.025.113.008.081v.06l-.011.106-.009.042-1.433 4.598a.818.818 0 01-1.026.528.814.814 0 01-.572-.896l.027-.116.683-2.192-10.935 6.179a4.776 4.776 0 00-1.778 6.61c1.33 2.254 4.215 3.078 6.535 1.906l.203-.109 4.258-2.406a1.11 1.11 0 011.497.4c.283.48.15 1.08-.288 1.4l-.107.069-4.258 2.405c-3.397 1.92-7.754.757-9.733-2.597a6.897 6.897 0 012.35-9.418l.218-.128 10.938-6.18-2.283-.515a.814.814 0 01-.623-.968.812.812 0 01.86-.623z",
    fill: "url(#skill-logo-fill)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsLogo);
export default __webpack_public_path__ + "abf0e2ac2e2015ddd8c168ca1c7bfbed.svg";
export { ForwardRef as ReactComponent };